import { useQuery } from "@tanstack/react-query";

import { getCurrentPrice } from "services";

import { DEFAULT_CACHE_TIME } from "consts";

import { PointPrices } from "models";

/**
 * This hook can be used to fetch the point prices per emission category. If the provided farm has a partner (insetting) this would return
 * the partner's prices, otherwise the regular one. The hook is also used in the context to cut down on network requests,
 * but you would need to use the hook directly if you need the point price in e.g. admin where the context does not provide it.
 *
 * @param {String} farmId Farm id of the farm you need the dynamic point price for
 * @returns {Object} Object of pointPrices (type of PointPrices) and a function to reload it
 */
export const usePointPrice = (farmId?: string): { pointPrices: PointPrices } => {
  const defaultData = {
    pointPriceCategory1: 0,
    pointPriceCategory2: 0,
    pointPriceCategory3: 0,
    pointPriceCategory4: 0,
  };

  const { data } = useQuery<PointPrices>({
    queryKey: ["getCurrentPrice", farmId],
    queryFn: ({ signal }) => getCurrentPrice({ farmId, signal }),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });

  return { pointPrices: data || defaultData };
};
